"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _get = _interopRequireDefault(require("lodash/fp/get"));

var _curry = _interopRequireDefault(require("lodash/fp/curry"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 *
 * A function which returns a comparison function that extracts values at a 
 * certain path, and runs given comparison function on those values.
 *
 * @name compareAtPath
 * @type Function
 * @param {String} path - Name of the path to values
 * @param {Function} func - Comparison function to run on values at specified path
 * @returns {Function} Comparison function
 *
 * @example
 * 
 * const people = [
 *  { name: 'Brad', age: 66 },
 *  { name: 'Georgina', age: 35 }
 * ]
 * 
 * const sortAscending = (a, b) => a - b
 *
 * const ageComparator = compareAtPath('age', sortAscending)
 *
 * people.sort(ageComparator)
 * 
 * // [
 * //   { name: 'Georgina', age: 35 },
 * //   { name: 'Brad', age: 66 },
 * // ]
 *
 */
function compareAtPath(path, func) {
  var getter = (0, _get["default"])(path);
  return function compare(a, b) {
    var _map = [a, b].map(getter),
        _map2 = _slicedToArray(_map, 2),
        aValue = _map2[0],
        bValue = _map2[1];

    return func(aValue, bValue);
  };
}

var _default = (0, _curry["default"])(compareAtPath);

exports["default"] = _default;